<template>
  <div class="how-to-join-section" role="region" aria-labelledby="join-title">
    <b-container fluid>
      <b-row class="align-items-center">
        <b-col md="8">
          <div>
            <h3 id="join-title" class="title">كيف يمكنني التسجيل؟</h3>
            <ol class="list" aria-label="خطوات التسجيل">
              <li class="d-flex align-items-start my-3">
                <div>
                  <h3 class="font-weight-bold mb-1">للطلبة</h3>
                  <p>قم بإنشاء حساب  
                    <b-link class="text-brand font-weight-bold" @click="goToSignup()"
                      aria-label="رابط إنشاء حساب"> من هنا </b-link>
                    <span v-if="false"> أو التطبيق .</span>
                    <span v-else>.</span>
                  </p>
                  <p>اختر المرحلة الدراسية والمناهج المطلوبة.</p>
                </div>
              </li>
              <li class="d-flex align-items-start my-3">
                <div>
                  <h3 class="font-weight-bold mb-1">للمعلمين</h3>
                  <p> تواصل معنا
                    <b-link class="text-brand font-weight-bold" @click="goToContactUs()"
                      aria-label="رابط إنشاء حساب"> من هنا </b-link>
                      <br>
                    </p>
                  <p>
                    أرسل سيرتك الذاتية وابدأ في التدريس بعد اجتياز التقييم.</p>

                </div>
              </li>
            </ol>
          </div>
        </b-col>

        <b-col md="4" class="text-center mb-4 mb-md-0">
          <img src="../../assets/images/how_to_join_img.png" alt="إرشادات التسجيل للموقع" loading="lazy" width="350"
            height="290" class="section-img" />
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'HowToJoin',
  methods: {
    goToSignup() {
      this.$router.push('/login');
    },
    goToContactUs() {
      this.$router.push('/contactus');
    }
  }
}
</script>

<style scoped>
.how-to-join-section {
  padding: 80px 85px !important;
}

.how-to-join-section .title {
  color: #000;
  font-size: 2.5rem !important;
  font-weight: bold !important;
  margin-bottom: 20px;
}

.how-to-join-section ol {
  padding-right: 0 !important;
}

.how-to-join-section .list {
  margin-bottom: 30px;
  padding-left: 20px;
}

.how-to-join-section .list h3 {
  font-size: 1.8rem !important;
}

.how-to-join-section .list p {
  font-size: 1.2rem !important;
  line-height: 1.6;
}

.section-img {
  width: 100%;
  max-width: 350px;
  height: auto;
}

.how-to-join-section a {
  color: var(--brand-teal);
  text-decoration: underline;
}

.how-to-join-section a:hover {
  text-decoration: none;
}

/* tablet */
@media (max-width: 991.98px) {
  .how-to-join-section {
    padding: 20px 30px 40px !important;
  }

  .how-to-join-section .title {
    font-size: 2rem !important;
  }

  .how-to-join-section img {
    width: 90% !important;
  }
}

/* mobile */
@media (max-width: 767.98px) {
  .how-to-join-section {
    padding: 10px 15px 30px !important;
  }

  .how-to-join-section .title {
    font-size: 1.8rem !important;
  }

  .how-to-join-section .list h3 {
    font-size: 1.4rem !important;
  }

  .how-to-join-section .list p {
    font-size: 1rem !important;
  }
}
</style>
